import React, { useEffect, useState } from 'react'
import './index.scss'
import Button from '../Common/Button'
import axios from 'axios'
import BASE_URL from '../../store/baseUrl'
import CustomModal from '../Common/Modal'

const deleteTemplate = () => {
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [message, setMessage] = useState(null)
    const [confimationModal, setConfirmationModal] = useState(false)
    const deleteAccount = async () => {
        try {
            await axios.post(
                `${BASE_URL}/deleteRequest?email=${email}&name=${name}`,
            )
            setMessage({ message: 'Request Submitted', code: 1 })
            setEmail('')
            setName('')
            setConfirmationModal(false)
        } catch (err) {
            console.log('error in deleting account ', err)
        }
    }

    const validate = () => {
        if (!name && !email) {
            setMessage({ message: 'Both name and email are required', code: 0 })
        } else {
            let validation = String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                )
            if (validation) {
                setConfirmationModal(true)
            } else {
                setMessage({ message: 'Invalid Email', code: 0 })
            }
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setMessage(null)
        }, 5000)
    }, [message])
    return (
        <div className="delete-account-container">
            <div>
                Fill your name and email to request for your account deletion
            </div>
            <div className="email-container">
                <div>Please enter your registered email id</div>
                <textarea
                    rows={1}
                    className="email-box"
                    placeholder="Email"
                    value={email}
                    onChange={(event) => {
                        setEmail(event.target.value)
                    }}
                />
            </div>
            <div className="email-container">
                <div>Please enter your name</div>
                <textarea
                    rows={1}
                    className="email-box"
                    placeholder="Name"
                    value={name}
                    onChange={(event) => {
                        setName(event.target.value)
                    }}
                />
            </div>
            {message && (
                <small style={{ color: message.code == 0 ? 'red' : 'green' }}>
                    {message.message}
                </small>
            )}
            <Button
                text={'Submit'}
                color={'green'}
                disabled={false}
                classNames="delete-button"
                onClick={() => {
                    validate()
                }}
            />
            <CustomModal
                title={'Confirmation'}
                show={confimationModal}
                onHide={() => setConfirmationModal(false)}
                width="small"
                dark={false}
                className="custom-modal-content"
            >
                <div>
                    <p>Your data will be deleted permanently</p>
                    <p>Are you sure you want to delete your account?</p>
                    <div className="d-flex">
                        <Button
                            text={'Yes'}
                            color="red"
                            size="s"
                            onClick={deleteAccount}
                        />
                        <Button
                            text={'No'}
                            color="green"
                            size="s"
                            onClick={() => setConfirmationModal(false)}
                        />
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}

export default deleteTemplate
